import React from 'react';

const BlogPost = () => {
  return (
    <div className="min-h-screen py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-4xl font-bold text-center mb-12">Blog Post</h1>
        <div className="text-center">
          <p className="text-xl text-gray-600">Blog post page coming soon...</p>
        </div>
      </div>
    </div>
  );
};

export default BlogPost;

